export const defaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Número de protocolo', value: 'protocol_number' },
  { label: 'Via', value: 'capture_method' },
  { label: 'Valor', value: 'total_amount' },
  { label: 'Cartão', value: 'card_last_four_digits' },
]
